import { Autocomplete, Box, Button, CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { AddExpenseValidation } from "../../../../helper/Validation";
import dayjs from "dayjs";
import { useForm } from "../../../../hooks/useForm";
import CustomInput from "../../../../components/CustomInput";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import DragAndDropMultiple from "../../../../components/DragAndDropMultiple";
import { LoadingButton } from "@mui/lab";
import style from "./style";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const ViewExpensePage = ({banks,types,loading,item,updateExpense}) => {
  const [date, setDate] = useState(dayjs(item?.date))
  const [paymentMode, setPaymentMode] = useState(item?.paidVia)
  const [bankDetails, setBankDetails] = useState(item?.bankName)
  const [edit, setEdit] = useState(false)
  const [type, setType] = useState(item?.expType)

  const editExpense = {
    name:{value:item?.name||"",error:"",focus:null},
    description:{value:item?.description||"",error:"",focus:null},
    taxAmount:{value:item?.tax||"",error:"",focus:null},
    amount:{value:item?.amount||"",error:"",focus:null},
  }
  const handleUpdateExpense = (data) => {
    updateExpense(item?._id,data,type,date,paymentMode,bankDetails)
  }

  const { state, handleChange, handleSubmit, handleFocus } = useForm(
    editExpense,
    AddExpenseValidation,
    handleUpdateExpense
  );
    
  useEffect(() => {
    if (window.intlTelInputGlobals) {
      window.intlTelInputGlobals.loadUtils("build/js/utils.js");
    }
  }, []);
    
  const {
    name,
    amount,
    taxAmount,
    description,
  } = state;
  return(
    <>
      <Box px="15px" pt="20px">
        <Box px="15px" display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h5" sx={style.heading}>{edit ? "Edit Expense" :"View Expense" }</Typography>
            
          {!edit && <Box display="flex" justifyContent={{ xs: "start", md: "end" }} alignItems={{ xs: "start", md: "end" }}>
            <Button variant="contained" color="success" sx={style.checkinBtn} onClick={() =>setEdit(true)}>
              {"Edit Expense"}
            </Button>
            
          </Box>}
            
            
        </Box>
        <form onSubmit={(e) => handleSubmit(e)}>
          
          <Box>
            <Grid container>
              <Grid item xs={12} sx={style.card}>
                <Box sx={style.inputSection}>
                  <Box sx={style.inputBox}>
                    <InputLabel sx={style.label}>
                    Name<span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <CustomInput
                      name="name"
                      fullWidth
                      placeholder="Enter Name"
                      defaultValue={item?.name}
                      value={name?.value}
                      readOnly={!edit}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={name?.error}
                    />
                  </Box>
                  <Box sx={style.inputBox}>
                    <InputLabel sx={style.label}>
                    Type<span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Autocomplete
                      id="autocomplete"
                      freeSolo
                      options={types || []}
                      readOnly={!edit}
                      getOptionLabel={(option) =>
                        typeof option === "string" ? option : option?.name
                      }
                      onInputChange={(event, newInputValue) => {
                        if(newInputValue?.length <= 50){
                          setType(newInputValue)
                        }
                      }}
                      onChange={(event, newValue) => {
                        setType(newValue?.name);
                      }}
                      value={type}
                      renderInput={(params) => (
                        <>
                          <TextField
                            placeholder="Expense Type"
                            {...params}
                            sx={{ ...style.modalInput, ...style.inputSpace }}
                            variant="outlined"
                            inputProps={{
                              ...params.inputProps,
                              maxLength: 50,
                            }}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loading ? (
                                    <CircularProgress color="inherit" size={20} />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        </>
                      )}
                    />
                  </Box>
                  <Box sx={style.inputBox}>
                    <InputLabel sx={style.label}>
                    Amount<span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <CustomInput
                      name="amount"
                      fullWidth
                      type="number"
                      defaultValue={item?.amount}
                      readOnly={!edit}
                      placeholder="Enter Amount"
                      value={amount?.value}
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={amount?.error}
                    />
                  </Box>
                
                </Box>
                <Box sx={style.inputSection}>
                  <Box sx={style.inputBox}>
                    <InputLabel sx={style.label}>
                    Tax Amount
                    </InputLabel>
                    <CustomInput
                      name="taxAmount"
                      fullWidth
                      readOnly={!edit}
                      defaultValue={item?.tax}
                      type="number"
                      value={taxAmount?.value}
                      placeholder="Enter Tax Amount"
                      onChange={handleChange}
                      onFocus={handleFocus}
                      error={taxAmount?.error}
                    />
                  </Box>

                  <Box sx={style.inputBox}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <InputLabel sx={style.label}>Date<span style={{ color: "red" }}>*</span></InputLabel>
                      <DatePicker sx={style.dateInput}
                        value={date}
                        readOnly={!edit}
                        onChange={(newValue) => {setDate(newValue);}}
                        maxDate={dayjs()}
                        slotProps={{
                          field: {
                            readOnly: true
                          }
                        }} />
                    </LocalizationProvider> 
                  </Box>              
                
                  <Box sx={style.inputBox}>
                    <FormControl
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.8em",
                          marginTop: "0.5em",
                          borderRadius: "10px",
                        },
                      }}
                    >
                      <Typography sx={style.label}>
                          Payment Method<span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Select
                        value={paymentMode || ""}
                        readOnly={!edit}
                        onChange={(event) =>{
                          setPaymentMode(event.target.value)
                          if(event?.target?.value !== "Bank"){
                            setBankDetails("")
                          }
                        }
                        }
                        name="PaymentMode"
                        sx={style.dropDownMenu}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                            Select
                        </MenuItem>
                        <MenuItem value="Cash">Cash</MenuItem>
                        <MenuItem value="Bank">Bank</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </Box>
                <Box sx={style.inputSections}>
                  <Box sx={style.inputBox}>
                    <FormControl
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          height: "2.8em",
                          marginTop: "0.5em",
                          borderRadius: "10px",
                        },
                      }}
                    >
                      <Typography sx={style.label}>Bank</Typography>
                      <Select
                        value={bankDetails || ""}
                        onChange={(event) =>{
                          setBankDetails(event.target.value)
                        }
                        }
                        readOnly={!edit}
                        disabled={paymentMode !== "Bank"}
                        name="bankDetails"
                        sx={style.dropDownMenu}
                        displayEmpty
                      >
                        <MenuItem disabled value="">
                            Select
                        </MenuItem>
                        {banks?.map((bank, index) => (
                          <MenuItem key={index} value={bank.name}>
                            {`${bank.name.toUpperCase()} - ${bank.accountNumber.slice(
                              -4
                            )}`}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  
                  </Box>
                  <Box sx={style.inputBox}>
                    <InputLabel sx={style.label}>Description</InputLabel>
                    <CustomInput
                      name="description"
                      fullWidth
                      value={description?.value}
                      readOnly={!edit}
                      defaultValue={item?.description}
                      onChange={handleChange}
                      placeholder="Description"
                      onFocus={handleFocus}
                      error={description?.error}
                    />
                  </Box>
                  <Box sx={style.inputBox}>
                    <InputLabel sx={style.label}>Upload File</InputLabel>
                    <DragAndDropMultiple />
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <Box px={2}>
              {edit && <LoadingButton
                //   loading={loading}
                variant="contained"
                sx={style.jobButtons}
                type="submit"
                disabled={!name?.value || name?.error || !amount?.value || amount?.error || !type || type?.error || taxAmount?.error || !date || !paymentMode || description?.error || paymentMode === "Bank" && !bankDetails}
              >
                {"Update Expense"}
              </LoadingButton>}
            </Box>
          </Box>
        </form>
      </Box>
    </>
  )
}

export default ViewExpensePage